import React from 'react';
import { Paper, Typography } from '@mui/material';

const Terms: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Terms & Conditions</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: 2025-10-17
      </Typography>
      <Typography variant="body1" paragraph>
        By using AskTheBill.ai, you agree to these Terms. The content on this site is provided for informational purposes only and does not constitute legal advice. We strive for accuracy but make no warranties regarding completeness, timeliness, or fitness for any particular purpose.
      </Typography>
      <Typography variant="body1" paragraph>
        You may use the site for personal, non-commercial purposes. Do not misuse the service, attempt to bypass security, or engage in scraping that violates our acceptable use. We may limit access or remove content at our discretion to protect the service and its users.
      </Typography>
      <Typography variant="body1" paragraph>
        All trademarks remain the property of their respective owners. Legislative data originates from public sources (e.g., Congress.gov). AI-generated content is experimental and should be independently verified.
      </Typography>
      <Typography variant="body1" paragraph>
        These Terms may change periodically. Continued use signifies acceptance of any updates.
      </Typography>
    </Paper>
  );
};

export default Terms;
